import React from "react"
import topImage from "./image/top.JPG"
import salesImage from "./image/sales.JPG"
import one from "./image/7.JPG"
import two from "./image/2.JPG"
import five from "./image/8.JPG"
import four from "./image/top.JPG"
import cat from "./image/cat.jpg"
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api"
import { HashLink } from "react-router-hash-link"

const key = process.env.REACT_APP_googleMapsApiKey
const containerStyle = {
  height: "100%",
  width: "100%",
}

const location = {
  lat: 36.541242,
  lng: 139.750471,
}

const center = {
  lat: 36.541242,
  lng: 139.750471,
}
const Map = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: key,
  })

  return isLoaded ? (
    <div className="md:m-0 md:w-7/12 md:h-128 w-full h-72 mb-9">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
        {/* Child components, such as markers, info windows, etc. */}
        <Marker position={location} />
      </GoogleMap>
    </div>
  ) : (
    <></>
  )
}

const Home = () => {
  return (
    <div className="">
      <div className="flex items-center justify-between m-8">
        <div className="title text-dark-purple">
          <h4 className="m-0 text-3xl md:text-5xl font-title">Suzuki</h4>
          <h5 className="font-mochiy text-md md:text-3xl">
            ブルーベリーファーム
          </h5>
        </div>
        <div className="flex text-dark-purple gap-2 md:gap-4 text-md md:text-xl">
          <HashLink smooth to="/#home" className="cursor-pointer">
            Home
          </HashLink>
          <HashLink smooth to="/#shop" className="cursor-pointer">
            Shop
          </HashLink>
          <HashLink smooth to="/#gallery" className="cursor-pointer">
            Gallery
          </HashLink>
          <HashLink smooth to="/#map" className="cursor-pointer">
            Map
          </HashLink>
        </div>
      </div>
      <div className="border-b border-dark-purple" />
      <div id="home" className="md:flex gap-12 justify-center items-center">
        <img className="md:w-7/12" src={topImage} alt="imageTop" />
        <div className="md:w-5/12 text-3xl md:text-4xl text-dark-purple m-8 md:m-0">
          <p class="text-xl mb-6 font-semibold">[Organic fruit]</p>
          <p className="font-mochiy">無農薬の</p>
          <p className="font-mochiy">贅沢なデザートを</p>
          <p className="font-mochiy">ぜひご家庭に。</p>
        </div>
      </div>
      <div className="md:flex md:gap-12 border-y md:p-12 border-dark-purple justify-between">
        <div
          id="shop"
          className="flex flex-col justify-center text-dark-purple m-8 md:m-0"
        >
          <p class="text-xl mb-6 font-semibold">Sales</p>
          <p class="text-3xl md:text-4xl mb-6 font-mochiy">
            無人販売やっています
          </p>
          <div className="text-xl font-semibold">
            <p>夏の暑い日に、冷たいブルーベリーはいかがですか？</p>
            <p>ヘルシーで甘く、ダイエットにももってこいの</p>
            <p>贅沢な夏のデザートをお手軽な値段でご用意しております。</p>
          </div>
          <div className="bg-dark-purple font-mochiy text-white my-6 p-6 text-center">
            <p>お値段</p>
            <p>小パック (9.5 cm x 3.5 cm) 200円</p>
            <p>大パック (13 cm x 5 cm) 500円</p>
          </div>
        </div>
        <img className="sm: mb-6 md:w-6/12" src={salesImage} alt="salesImage" />
      </div>
      <div>
        <div
          id="gallery"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-b border-dark-purple"
        >
          <div className="p-6 border-b md:border-r md:border-b-0 border-dark-purple">
            <img className="" src={one} alt="1" />
            <div className="text-l font-semibold text-dark-purple my-6">
              <p class="text-xl mb-6">目の疲れに効く</p>
              <p>
                ブルーベリーにはビタミン、ミネラル、食物繊維など、様々な栄養素が含まれており、スーパーフードとして注目されています。
              </p>
              <p>
                中でもアントシアニンと呼ばれる栄養素は、目の疲れや視力低下の予防にも効果があると言われています。{" "}
              </p>
            </div>
          </div>
          <div className="p-6 border-b md:border-r md:border-b-0 border-dark-purple">
            <img className="" src={two} alt="2" />
            <div className="text-l font-semibold text-dark-purple my-6">
              <p class="text-xl mb-6">冷凍保存に最適</p>
              <p>
                ブルーベリーを冷凍すると生のブルーベリーよりも栄養価が上がるってご存知でしたか？
              </p>
              <p>
                ブルーベリーを冷凍することにより、栄養素を吸収しやすくなると言われています。
              </p>
              <p>その上ジャムなどにしても栄養価が変わることはありません。</p>
            </div>
          </div>
          <div className="p-6 border-b md:border-r md:border-b-0 border-dark-purple">
            <img className="" src={five} alt="3" />
            <div className="text-l font-semibold text-dark-purple my-6">
              <p class="text-xl mb-6">食物繊維で便秘予防！</p>
              <p>
                ブルーベリーに含まれる食物繊維は、第五栄養素に加え、第６の重要栄養素として注目されています。
              </p>
              <p>
                特に食物繊維は腸の働きを助ける効果があり、便秘予防に効果があると言われております。
              </p>
            </div>
          </div>
          <div className="p-6">
            <img className="" src={four} alt="4" />
            <div className="text-l font-semibold text-dark-purple my-6">
              <p class="text-xl mb-6">アンチエイジングに効果あり</p>
              <p>
                ブルーベリーに含まれるビタミンの中でも、ビタミンCは体内の免疫力を高める作用やコラーゲンの生成を助ける作用もあり、肌の若返りが期待できます。
              </p>
              <p>
                しかし加熱処理するとビタミンCは壊れやすいため注意しましょう。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        id="map"
        className="md:flex gap-12 border-b p-8 md:p-12 border-dark-purple justify-between"
      >
        <Map />
        <div className="flex flex-col justify-center text-dark-purple md:w-6/12">
          <p class="text-xl mb-6 font-semibold">Map</p>
          <p class="text-3xl md:text-4xl mb-6 font-mochiy">お店までの地図</p>
          <div className="text-xl font-semibold">
            <p>お気軽にお越しください♪</p>
            <br />
            <p>〒322-0045　栃木県鹿沼市上殿町124−1</p>
            <p>電話番号　0289(62)1182</p>
          </div>
        </div>
      </div>
      <div className="md:flex gap-12 border-b p-8 md:p-12 border-dark-purple justify-between">
        <div className="flex flex-col justify-center">
          <p className="text-3xl md:text-4xl mb-6 font-mochiy text-dark-purple">
            お待ちしております♪
          </p>
        </div>
        <img className="md:w-6/12" src={cat} alt="cat" />
      </div>
      <div className="md:flex gap-32 bg-light-purple text-white px-12 md:px-24 py-12">
        <div>
          <p className="text-xl md:text-2xl mb-6 font-mochiy">
            Suzuki ブルーベリーファーム
          </p>
          <p className="text-xl mb-6">お問い合わせ</p>
          <p className="text-xl ">住所　３２２−００４５　</p>
          <p className="text-xl mb-6">　　　栃木県鹿沼市上殿町１２４−１</p>
          <p className="text-xl mb-6">電話番号 （０２８９）６２−１１８２</p>
        </div>
        <div>
          <p className="text-2xl mb-6 ">営業時間</p>
          <div className="flex">
            <p className="text-xl mb-2">月曜日</p>
            <p className="text-xl mb-2">　　　9:00 - 18:00</p>
          </div>
          <div className="flex">
            <p className="text-xl mb-2">火曜日</p>
            <p className="text-xl mb-2">　　　9:00 - 18:00</p>
          </div>
          <div className="flex">
            <p className="text-xl mb-2">水曜日</p>
            <p className="text-xl mb-2">　　　9:00 - 18:00</p>
          </div>
          <div className="flex">
            <p className="text-xl mb-2">木曜日</p>
            <p className="text-xl mb-2">　　　9:00 - 18:00</p>
          </div>
          <div className="flex">
            <p className="text-xl mb-2">金曜日</p>
            <p className="text-xl mb-2">　　　9:00 - 18:00</p>
          </div>
          <div className="flex">
            <p className="text-xl mb-2">土曜日</p>
            <p className="text-xl mb-2">　　　9:00 - 18:00</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
